import {
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import Iconify from './Iconify';

const DatagridToolbar = () => {
    return (
        <GridToolbarContainer sx={{ backgroundColor: 'transparent' }}>
            <GridToolbarColumnsButton
                startIcon={<Iconify icon="mingcute:calendar-week-line" width={20} height={20} />}
            />
            <GridToolbarDensitySelector
                startIcon={
                    <Iconify
                        icon="mingcute:calendar-week-line"
                        width={20}
                        height={20}
                        sx={{ transform: 'rotate(90deg)' }}
                    />
                }
            />
        </GridToolbarContainer>
    );
};

export default DatagridToolbar;
